import React, { useEffect } from 'react';

const ThankYou = () => {
  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      window.location.href = 'https://app.behooked.co';
    }, 2000);
    
    return () => clearTimeout(redirectTimer);
  }, []);

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">
          <i className="checkmark">✓</i>
        </div>
        <h1>Success</h1>
        <p>Your payment was successful!</p>
        <p>Thank you for your subscription to BeHooked.</p>
        <p>We've sent a confirmation email with your receipt.</p>
        <p className="redirect-message">Redirecting you to the app in 2 seconds...</p>
        <button onClick={() => window.location.replace('/')} className="home-btn">
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
